var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgGuestRulesGrTimeClock = function SvgSvgGuestRulesGrTimeClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 23.501c6.351 0 11.5-5.149 11.5-11.5S18.35.501 11.999.501.499 5.65.499 12.001s5.149 11.5 11.5 11.5Z",
    fill: "#66E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.867 20.133A11.5 11.5 0 1 1 20.131 3.869L3.867 20.133Z",
    fill: "#C2F3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.501c6.351 0 11.5-5.149 11.5-11.5S18.351.501 12 .501.5 5.65.5 12.001s5.149 11.5 11.5 11.5ZM18 18.001l-4.943-4.942",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.501a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#FFEF5E",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.501v4",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgGuestRulesGrTimeClock;